import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CompassEnums } from '@sellsy/compass2';

interface Props {
    size?: CompassEnums.AlertSize;
    actionPosition?: CompassEnums.AlertActionPosition;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ComplianceAlert',
  props: {
    size: { default: CompassEnums.AlertSize.MEDIUM },
    actionPosition: { default: CompassEnums.AlertActionPosition.BOTTOM }
  },
  setup(__props: any) {



const openComplianceFaq = (): void => {
    const url =
        'https://help.sellsy.com/fr/articles/14756178-les-informations-obligatoires-d-une-facture';
    window.open(url, '_blank');
};

return (_ctx: any,_cache: any) => {
  const _component_CompassAlert = _resolveComponent("CompassAlert")!

  return (_openBlock(), _createBlock(_component_CompassAlert, {
    type: _unref(CompassEnums).AlertType.NEUTRAL,
    description: _ctx.$t.__('document.DocFormLayout.alert_compliance'),
    showClose: false,
    size: __props.size,
    action: {
            label: _ctx.$t.__('common.labels.learn_more'),
            callback: openComplianceFaq,
        },
    actionPosition: __props.actionPosition
  }, null, 8 /* PROPS */, ["type", "description", "size", "action", "actionPosition"]))
}
}

})